<template>
  <div
    class="pl-3 pr-2"
    :class="{ 'w-1/4': sideFilters }"
    style="scrollbar-gutter: stable"
  >
    <filter-display
      v-bind="{ filters, filtersQuery, currency, sideFilters }"
      class="b-t b-grey-70 py-2"
      :max-collapsed-rows="{ sm: 2, md: 1, lg: 2 }"
      @clear="$emit('clear')"
      @remove="$emit('remove', $event)"
    />
    <template v-if="Object.keys(filters)?.length">
      <vf-accordion
        v-for="(filter, code, i) in filters"
        :key="code"
        :open="i < sideFilterOpenFacets"
        size="sm"
        :title="filter.label"
        variant="aligned"
      >
        <filter-options
          v-bind="{ filter, code }"
          class="pb-6 pt-2"
          :currency
          :loading
          :model-value="filters[code].selected"
          @update:model-value="$emit('change', { code: `${code}`, selected: $event! })"
        />
      </vf-accordion>
    </template>
    <product-list-skeleton v-else-if="loading" />
  </div>
</template>

<script lang="ts" setup>
import type { FiltersMap } from '#types/filters'

defineProps<{
  sideFilters?: boolean
  currency?: string
  loading?: boolean
  filters: FiltersMap
  filtersQuery?: Record<string, string[]>
}>()

defineEmits<{
  clear: []
  remove: [payload: { code: string, id: string }]
  change: [payload: { code: string, selected: string[] }]
  changeStore: [payload?: string]
  sort: [payload: string]
}>()

const { sideFilterOpenFacets } = useAppConfig().components.product.list
</script>
